import React from "react";
import { Row, Col, Icon } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { googleAds } from "appConfig";

import styles from "./styles/OtherCategories.scss";
import { selectModules } from "../App/selectors";
import {
  formatNumber,
  getWindowWidth,
  isMobileScreen,
  stringifyURI
} from "../../services/utils";
import IndexImage from "../IndexImage";
import { getImageUrl } from "../../services/asset";
import {
  AdsSortOption,
  CategoryName,
  CategoryNameHr,
  ModuleName,
  ModuleNameHr,
  PageRoute,
  QueryParam
} from "../../models";
import GoogleAd from "../../components/GoogleAd";

const defaultCategory = CategoryName.housesForSale;

function OtherCategories({ modules, redirectUrl, className, showGoogleAds }) {
  const getModuleLink = module => {
    if (
      module.name == ModuleName.realEstate || 
      module.route == ModuleNameHr.realEstate
    ) {
      const query = {
        category: defaultCategory
      };

      return `/${module.route}/${CategoryNameHr.housesForSale}${stringifyURI(query, QueryParam.searchQuery)}`;
    }

    if (
      module.name == ModuleName.tourism || 
      module.route == ModuleNameHr.tourism
    ) {
      const query = {
        module: ModuleNameHr.tourism,
        category: CategoryNameHr.apartmentsRoomsHouses,
        sortOption: AdsSortOption.DateDesc
      };
      return `/${module.route}/${CategoryNameHr.apartmentsRoomsHouses}${
        PageRoute.search
      }$${stringifyURI(query, QueryParam.searchQuery)}`;
    }

    return `/${module.route}${redirectUrl}`;
  };

  const isMobile = isMobileScreen(getWindowWidth());

  return (
    <div className={`${className} ${styles.container}`}>
      <Row align="top" type="flex" justify="center">
        {modules.map((module, index) => (
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={8}
            xxl={6} 
            key={module.name}
            className={styles.module}
          >
            {showGoogleAds && index === 7 ? (
              <GoogleAd
                className={styles.ads}
                config={{
                  ...googleAds.homePageMobile.box3,
                  id: "googleAds.homePageMobile.box3"
                }}
              />
            ) : null}
            <Link title={module.displayName} to={getModuleLink(module)}>
              <div className={styles.card}>
                <div className={styles.iconContainer}>
                  <IndexImage
                    className={styles.icon}
                    alt={module.displayName}
                    src={`${getImageUrl(module.name)}.png`}
                  />
                </div>
                <span className={styles.data}>
                  <div className={styles.name}>
                    <span>{module.displayName}</span>
                    <span className={styles.adCount}>
                      {formatNumber(module.count)}
                    </span>
                  </div>
                  {isMobile && (
                    <Icon
                      type="right"
                      className={`more-search-arrow ${styles.arrow}`}
                    />
                  )}
                </span>
              </div>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}

OtherCategories.defaultProps = {
  title: "Kategorije",
  modules: [],
  redirectUrl: "",
  className: "",
  showGoogleAds: false
};

function mapStateToProps(state) {
  return {
    modules: selectModules(state)
  };
}

export default connect(mapStateToProps)(OtherCategories);



// WEBPACK FOOTER //
// ./src/containers/HomePage/OtherCategories.tsx